import { tsInitVueGrid } from './js-utils'
import CompletionCertificatesGrid from '../js/vue-components/completion-certificates-grid.vue'

document.addEventListener('DOMContentLoaded', function () {
  const certGridEl = document.querySelector('body.event-completion-certificates div[data-is="CompletionCertificatesGrid"], body.ospe-activity-completion-certificates div[data-is="CompletionCertificatesGrid"]')
  if (certGridEl instanceof HTMLElement) {
    window.certificatesGrid = tsInitVueGrid(CompletionCertificatesGrid, certGridEl, {
      showTotalRecords: certGridEl.dataset.showTotalRecords == 'true',
    })
  }
})
